import { Autocomplete, Button, FormHelperText, Grid2, TextField, Typography, useTheme } from '@mui/material';
import { Formik } from 'formik';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { dispatch } from 'store';
import { useUpdateWorkFlowMutation } from 'store/slices/apis/keyIssueSlice';
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';
import * as Yup from 'yup';

const currentStatuses = [
    { label: "Approve" },
    { label: "Reject" },
];

export default function AddIssueComment(props) {
    const { id, rowData } = props;
    const theme = useTheme();
    const navigate = useNavigate();
    const { projectId } = useParams();
    const formikRef = React.useRef();
    const [updateWorkFlow, updateWorkFlowRes] = useUpdateWorkFlowMutation();
    const [formData, setFormData] = React.useState({
        Comment: '',
        Status: '',
        // data: JSON.stringify(rowData),
        LinkUrl: `http://pmis-tool.s3-website.eu-north-1.amazonaws.com/verify/issue/${id}`,
        Type: 'Issue',
    })

    const handleSubmit = async (values) => {
        // await updateWorkFlow(values);
        await updateWorkFlow({ ...values, ParentId: rowData?.id, data: JSON?.stringify(rowData) })
    }


    React.useEffect(() => {
        if (updateWorkFlowRes?.isSuccess) {
            if (updateWorkFlowRes?.data?.status == 'Success') {

                formikRef.current?.resetForm();
                openNotification(updateWorkFlowRes?.data?.message, 'success')
                navigate(`/projects/${projectId}/my-work`);
            } else {
                openNotification(updateWorkFlowRes?.data?.message, 'error')
            }
        }
    }, [updateWorkFlowRes?.isSuccess]);

    React.useEffect(() => {
        if (updateWorkFlowRes?.isError) {
            if (updateWorkFlowRes?.error?.data?.status == 'fail') {
                openNotification(updateWorkFlowRes?.error?.data?.message, 'error')
            } else {
                openNotification(updateWorkFlowRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [updateWorkFlowRes?.isError]);

    const validationSchema = Yup.object({
        Status: Yup.string().required("Status field is required."),
        Comment: Yup.string().required("Comment field is required.")
    });

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };

    return (
        <Formik
            innerRef={formikRef}
            initialValues={formData}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                <form onSubmit={handleSubmit}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={12}>
                            <Autocomplete
                                options={currentStatuses}
                                getOptionLabel={(option) => option?.label}
                                value={currentStatuses.find((option) => option.label === values?.Status) || null}
                                onChange={(_, newValue) => setFieldValue("Status", newValue ? newValue.label : "")}
                                onBlur={() => setTouched({ ...touched, Status: true })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        placeholder='Select Status'
                                        name="Status"
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        variant="filled"
                                    />
                                )}
                                ListboxProps={{
                                    sx: { fontSize: "13px" },
                                }}
                            />
                            {touched?.Status && errors?.Status &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.Status}`}</FormHelperText>
                            }
                        </Grid2>
                        {values?.status != 'Approved without Comment' &&
                            <Grid2 size={12}>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Comment"
                                    name="Comment"
                                    multiline
                                    fullWidth
                                    rows={3}
                                    value={values?.Comment}
                                    onChange={handleChange}
                                    onBlur={() => setTouched({ ...touched, Comment: true })}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    variant="filled"
                                />
                                {touched?.Comment && errors?.Comment &&
                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.Comment}`}</FormHelperText>
                                }
                            </Grid2>
                        }

                        <Grid2 size={12}>
                            <Button type='submit'
                                variant="contained"
                                loading={updateWorkFlowRes?.isLoading}
                                sx={{
                                    backgroundColor: `${theme?.customSettings?.themeColor}`,
                                    color: '#fff',
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    textTransform: 'none',
                                    float: 'right'
                                }}>
                                Save
                            </Button>
                        </Grid2>
                    </Grid2>
                </form>
            )}
        </Formik>
    );
}